import {CacheState} from "./CacheState";
import {User} from "../../model/user/User";

export class UserListState implements CacheState {
    constructor(public users: User[] = [],
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}